<template>
  <div>
    <vs-popup
      v-if="selectedBoardTemplateId"
      title="Board Configuration"
      :active.sync="showConfiguration"
      :button-close-hidden="true"
      class="template-popup"
    >
      <board-configuration
        :boardId="selectedBoardTemplateId"
        @close-board-details-popup="closeBoardDetailPopup"
      />
    </vs-popup>

    <div class="vx-row">
      <div
        v-for="(board, index) in boardTemplates"
        :key="index"
        class="vx-col w-full lg:w-1/3 mb-base"
      >
        <vx-card class="org-card board-card" style="min-height: 402px">
          <div
            slot="no-body"
            :style="{ background: board.backgroundColor }"
            style="border-radius: 8px 8px 0 0"
          >
            <div class="py-5 items-center">
              <img
                :src="board.icon"
                alt="content-img"
                class="card-img-topp"
                width="140px"
                height="140px"
              />
            </div>
          </div>
          <h5 class="board-title mb-2">{{ board.title }}</h5>
          <p class="board-description">
            {{ board.description.slice(0, 90) }}...
          </p>
          <div slot="footer">
            <vs-button
              v-if="board.id === 'custom-board'"
              class="w-full py-5"
              type="filled"
              color="primary"            
              @click.stop="selectBoardTemplate(board.id)"
              >Create a Custom Board</vs-button
            >
            <vs-button
              v-else
              class="w-full py-5"
              type="filled"
              color="primary"
              @click.stop="selectBoardTemplate(board.id)"
              >Select Board Template</vs-button
            >
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import BoardConfiguration from "../components/BoardConfiguration.vue";
import boardTemplates from "@/assets/data/board-templates.js";

export default {
  data() {
    return {
      boardTemplates,
      showConfiguration: false,
      selectedBoardTemplateId: null,
    };
  },
  components: {
    BoardConfiguration,
  },
  methods: {
    selectBoardTemplate(id) {
      this.selectedBoardTemplateId = id;
      this.showConfiguration = true;
    },
    closeBoardDetailPopup() {
      this.showConfiguration = false;
    },
  },
};
</script>

<style scoped>
.board-card .board-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  /* identical to box height, or 178% */

  color: #000000;
}

.board-card .board-description {
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  /* Light Slate Grey */

  color: #798ba0;
}

.template-popup >>> .vs-popup--header {
  display: none !important;
}

.template-popup >>> .vs-popup {
  width: 950px;
}

.con-vs-popup >>> .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  width: auto !important;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.blank-board.card-overlay::after {
  background-color: transparent;
}
</style>
